import { useLocalize } from '@treams/treams-hooks/useLocalize';

import { sortByOrderThenTitle } from '../../competencies/sortJobCompetenciesByOrder';
import { GrowthPathJobCompetency } from '../types';

export function useGrowthPathJobCompetencyFilter(
	labelID: string | null,
	jobCompetencies: GrowthPathJobCompetency[],
): GrowthPathJobCompetency[] | undefined {
	const { localize } = useLocalize();

	const filtered =
		labelID && labelID !== 'unlabeled'
			? jobCompetencies.filter(
					(jobCompetency) =>
						jobCompetency.competency.label && jobCompetency.competency.label.id === labelID,
				)
			: jobCompetencies.filter((jobCompetency) => jobCompetency.competency.label === null);

	return sortByOrderThenTitle(
		filtered,
		(jobCompetency) => jobCompetency.order,
		(jobCompetency) => localize(jobCompetency.competency.title ?? []).text,
	);
}
